<template>
    <div class="mt-1 ml-2 text-sm text-green-600">{{ $t('text.new') }}</div>
</template>

<script>
    export default {
        name: "New"
    }
</script>

<style scoped>

</style>